import { readableOn } from "@/lib/forumColors";

export const PAPER_PALETTE = [
  "#FEF08A",
  "#FDE68A",
  "#FED7AA",
  "#FCA5A5",
  "#FBCFE8",
  "#DDD6FE",
  "#C7D2FE",
  "#BFDBFE",
  "#A7F3D0",
  "#BBF7D0",
  "#99F6E4",
  "#E7E5E4",
];

export const DEFAULT_PAPER = "#FEF08A";

export const TEXTURES = [
  { value: "plain", label: "Plain" },
  { value: "lined", label: "Ruled" },
  { value: "graph", label: "Graph" },
  { value: "kraft", label: "Kraft" },
  { value: "cork", label: "Cork" },
  { value: "tape", label: "Taped" },
  { value: "paisley", label: "Paisley" },
  { value: "paisley_dense", label: "Paisley dense" },
];

export const PRIORITIES = [
  { value: "high", label: "High" },
  { value: "normal", label: "Normal" },
  { value: "low", label: "Low" },
];

const svg = (markup) => `url("data:image/svg+xml,${encodeURIComponent(markup)}")`;

const paisley = (ink, size) =>
  svg(
    `<svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 64 64'>` +
      `<g fill='none' stroke='${ink}' stroke-width='1.6' stroke-linecap='round'>` +
      `<path d='M32 7c11 0 20 8 20 18 0 12-10 17-17 22-5 4-9 7-9 12 0-8 4-12 10-16 6-4 11-7 11-14 0-8-7-14-15-14s-15 6-15 14c0 4 2 7 4 9'/>` +
      `<circle cx='32' cy='26' r='4.2'/>` +
      `<path d='M4 48c5 4 11 6 17 6'/><path d='M52 4c4 3 7 7 8 12'/>` +
      `</g></svg>`,
  );

const cork = (ink) =>
  svg(
    `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'>` +
      `<g fill='${ink}'>` +
      `<circle cx='6' cy='8' r='2.4'/><circle cx='22' cy='4' r='1.6'/><circle cx='33' cy='13' r='2.8'/>` +
      `<circle cx='13' cy='20' r='1.8'/><circle cx='27' cy='26' r='2.2'/><circle cx='4' cy='31' r='2'/>` +
      `<circle cx='19' cy='36' r='1.5'/><circle cx='36' cy='33' r='1.7'/>` +
      `</g></svg>`,
  );

const kraft = () =>
  svg(
    `<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'>` +
      `<filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/>` +
      `<feColorMatrix type='saturate' values='0'/></filter>` +
      `<rect width='120' height='120' filter='url(%23n)' opacity='0.32'/></svg>`,
  );

/** Layered CSS background for a note's paper. */
export const paperStyle = (color, texture) => {
  const paper = color || DEFAULT_PAPER;
  const dark = readableOn(paper) === "#FFFFFF";
  const ink = dark ? "rgba(255,255,255,0.34)" : "rgba(23,23,23,0.16)";
  const strong = dark ? "rgba(255,255,255,0.5)" : "rgba(23,23,23,0.26)";
  const base = { background: paper, color: dark ? "#F8FAFC" : "#151515" };

  switch (texture) {
    case "lined":
      return {
        ...base,
        backgroundImage: `repeating-linear-gradient(to bottom, transparent 0 26px, ${ink} 26px 27px)`,
      };
    case "graph":
      return {
        ...base,
        backgroundImage:
          `repeating-linear-gradient(to bottom, transparent 0 15px, ${ink} 15px 16px), ` +
          `repeating-linear-gradient(to right, transparent 0 15px, ${ink} 15px 16px)`,
      };
    case "kraft":
      return { ...base, backgroundImage: kraft(), backgroundSize: "120px 120px" };
    case "cork":
      return { ...base, backgroundImage: cork(strong), backgroundSize: "40px 40px" };
    case "paisley":
      return { ...base, backgroundImage: paisley(strong, 64), backgroundSize: "64px 64px" };
    case "paisley_dense":
      return { ...base, backgroundImage: paisley(strong, 34), backgroundSize: "34px 34px" };
    default:
      return base;
  }
};

export const inkOn = (color) => (readableOn(color || DEFAULT_PAPER) === "#FFFFFF" ? "light" : "dark");

export const scrimStyle = (color) =>
  inkOn(color) === "light"
    ? { background: "rgba(9,9,11,0.62)", color: "#F8FAFC" }
    : { background: "rgba(255,255,255,0.78)", color: "#151515" };
